module.exports = __webpack_public_path__ + "static/media/only-the-brave.fb1101e0.png";